export default ({ instance }) => {
	return {
		login(usuario) {
			return instance({
				method: "post",
				url: "autenticacao",
				data: usuario,
			});
		},

		autenticarEmailSenha(usuario) {
			return instance({
				method: "post",
				url: "autenticacao/autenticar-email-senha",
				data: usuario,
			});
		},

		validarRecaptchaV3(token) {
			return instance({
				method: "post",
				url: "autenticacao/validar-recaptcha-v3",
				data: { token },
			});
		},

		fazerLogin(usuario) {
			return instance({
				method: "post",
				url: "autenticacao/fazer-login",
				data: usuario,
			});
		},

		linkNovaSenha(acao) {
			return instance({
				method: "post",
				url: "autenticacao/email-criar-senha",
				data: acao,
			});
		},

		verificarValidadeToken(token) {
			return instance({
				method: "get",
				url: "autenticacao/verificar-token/" + token,
			});
		},

		cadastrarNovaSenha(senha) {
			return instance({
				method: "post",
				url: "autenticacao/nova-senha",
				data: senha,
			});
		},

		aceiteTermoUso() {
			return instance({
				method: "post",
				url: "autenticacao/aceite-termo",
			});
		},

		responderPesquisaSatisfacao(resposta) {
			return instance({
				method: "post",
				url: "autenticacao/pesquisa-satisfacao",
				data: resposta,
			});
		},

		consultarEmailValido() {
			return instance({
				method: "get",
				url: "autenticacao/consultar-email",
			});
		},

		responderPesquisaProcon(resposta) {
			return instance({
				method: "post",
				url: "autenticacao/pesquisa-procon/" + resposta,
			});
		},
	};
};
